<template>
    <div class="kgk-team-invite">
        <h3>Neues Mitglied zum Team hinzufügen</h3>
        <div v-if="canInvite">
            <p>
                <i class="fas fa-info-circle"></i>
                Dein Team kann aus unbegrenzt vielen Läufern bestehen.
                <!-- Dein Team kann aus bis zu 150 Läufern bestehen. // @TODO: team max size magic number -->
            </p>
            <button type="button" @click.prevent="inviteUsersButton()">
                <i class="fas fa-user-plus"></i>
                <span class="button-text">Läufer ins Team einladen</span>
            </button>
            <br/>
            <br/>
        
            <p>
                <i class="fas fa-info-circle"></i>
                Du kannst diesen Link teilen und so Nutzer deinem Team hinzufügen. Auch Personen, die noch keinen Account haben, treten dem Team direkt nach ihrer Registrierung über diesen Link bei.
            </p>
            <textarea id="inviteMassLink" readonly style="border:1px solid #000" v-model="inviteLink"></textarea>
            <p>
                <button type="button" @click.prevent="copyToClipboard()">
                    <span class="button-text">Kopieren</span>
                </button>
                <button type="button" @click.prevent="inviteViaEmail()">
                    <i class="fas fa-envelope"></i>
                    <span class="button-text">Per E-Mail einladen</span>
                </button>
            </p>
        </div>
        <div v-else>
            <p>Du kannst keine weiteren Teammitglieder hinzufügen, da die maximale Teamgröße erreicht ist.</p>
        </div>
    </div>
</template>

<script>
    import team from '../../api/team';

    import UserSearch from './UserSearch';

    export default {
        name: 'TeamInvite',
        props: {
            teamIdentifier: String,
            canInvite: {
                type: Boolean,
                required: true
            },

        },
        data() {
            return {
                selection: [],
                inviteLink: ''
            }
        },
        computed: {

        },
        methods: {
            copyToClipboard() {
                const textarea = document.getElementById('inviteMassLink');
                textarea.select();
                document.execCommand('copy');
            },
            inviteViaEmail() {
                const subject = 'Lauf mit in meinem Team!';
                const body = `Hallo,\n\nich lade dich ein, meinem Team beizutreten und gemeinsam Kilometer zu sammeln.\n\nKlicke auf den folgenden Link, um dich zu registrieren und automatisch dem Team beizutreten:\n${this.inviteLink}\n\nBis bald!`;

                window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            },
            inviteUsersButton() {
                const _this = this;

                let fired = false;

                //this.$modal.show('team-add-member');

                this.$modal.show('dialog', {
                    title: 'Läufer ins Team einladen',
                    component: UserSearch,
                    props: {
                        excludeTeam: this.teamIdentifier,
                    },
                    on: {
                        'selected': _this.handleSelection
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            default: true,
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        {
                            title: 'Ausgewählte einladen',
                            handler() {
                                if( fired ) {
                                    return;
                                }

                                if( _this.selection.length < 1 ) {
                                    return;
                                }

                                fired = true;
                                this.title += ' <i class="fas fa-spinner fa-spin"></i>';
                                _this.addSelectionToTeam(
                                    () => {
                                        _this.$emit('invited');
                                    },
                                    () => _this.$modal.hide('dialog')
                                );
                            }
                        }
                    ]
                });
            },
            handleSelection(selectedUsers) {
                //console.log('handleSelection', selectedUsers, this);
                this.selection = selectedUsers;
            },
            addSelectionToTeam(callback, finallyCallback) {
                team.invite(
                    this,
                    this.selection.map(user => ({
                        identifier: user.identifier,
                        id: user.id
                    })),
                    data => {
                        //console.log(data);

                        let notificationText = [];

                        const invitedUsers = data.invitedUsers || [];
                        const alreadyInvitedUsers = data.alreadyInvitedUsers || [];

                        if( invitedUsers.length == 1 ) {
                            notificationText.push(`Der Läufer <b>${invitedUsers[0].username}</b> wurde in Ihr Team eingeladen.`);
                        }
                        else if( invitedUsers.length > 1 ) {
                            notificationText.push(`Die Läufer <b>${invitedUsers.map(user => user.username).join(', ')}</b> wurden in Ihr Team eingeladen.`);
                        }

                        if( alreadyInvitedUsers.length == 1 ) {
                            notificationText.push(`Für den Läufer <b>${alreadyInvitedUsers[0].username}</b> ist bereits eine Einladung ausstehend bzw. er ist bereits Teammitglied.`);
                        }
                        else if( alreadyInvitedUsers.length > 1 ) {
                            notificationText.push(`Für die Läufer <b>${alreadyInvitedUsers.map(user => user.username).join(', ')}</b> sind bereits Einladungen ausstehend bzw. sie sind bereits Teammitglieder.`);
                        }

                        this.$notify({
                            type: 'success',
                            title: 'Läufer eingeladen',
                            text: notificationText.join("<br>")
                        });

                        if( callback ) {
                            callback();
                        }
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => {
                        if( finallyCallback ) {
                            finallyCallback();
                        }
                    }
                )
            },
            // The invite link has to be a real InviteLink.identifier (backend
            // validates against the invite_links table) -- reuse an existing
            // active one if there is one, otherwise mint a new one.
            loadInviteLink() {
                team.inviteLinks(
                    this,
                    data => {
                        const active = (data.inviteLinks || []).find(l => l.status === 'active');
                        if (active) {
                            this.setInviteLink(active.identifier);
                        } else {
                            this.generateInviteLink();
                        }
                    },
                    () => this.generateInviteLink(),
                );
            },
            generateInviteLink() {
                team.generateInviteLink(
                    this,
                    data => this.setInviteLink(data.inviteLink.identifier),
                    () => {},
                );
            },
            setInviteLink(identifier) {
                this.inviteLink = `${window.baserouteApp}#/team/acceptInviteMass/${identifier}`;
            },
        },
        mounted() {
            this.loadInviteLink();
        }
    }
</script>
